// extracted by mini-css-extract-plugin
module.exports = {"block":"lEm-uvCuWEL7z-GBlsI4i","modalBlock":"HbqLwcVmPN9XtH_xFpdas","modalFixed":"_2OyYVwab1nU4jZJE4Dlpx","content":"_3ak5oWuTpP_sq9F_DMgYif","news":"_3VtQCLfDRqYeCQiwiE3J1P"};